<template>
			<div class="billing-page main-content layout-column scroll" :class="{ 'main-content_3': step === 3 }">
				<h1 class="main_page_title" >Billing</h1>

				<ul class="header_tabs" v-if="step !=='active-billing'">
					<li>
						<label @click="gotoChooseYourPlan" class="form_steps_label step_1"
						       :class="[{'current': step==='choose-your-plan'}, {'active': step==='checkout'}]">
							<span class="icon"></span> Choose your plan
						</label>
					</li>
					<li>
						<label class="form_steps_label step_1" :class="[{'de_active': !step},{'current': step==='checkout'}]">
							<span class="icon"></span> Checkout
						</label>
					</li>
				</ul>

				<router-view ></router-view>

			</div>
</template>

<script>
import VButton from "@/components/base/v-button";
import MainSearch from "@/components/MainSearch.vue";
import ChooseYourPlan from "@/views/settings/billing/choose-your-plan";
import checkout from "@/views/settings/billing/checkout";
import PaymentSuccessful from "@/views/settings/billing/payment-successful";
import ActiveBilling from "@/views/settings/billing/active-billing";
import API from '@/api';

export default {
	name: "Billing",
	mixins:[API],
	components: {
		PaymentSuccessful,
		VButton,
		MainSearch,
		ChooseYourPlan,
		checkout,
		ActiveBilling,
	},
	data() {
    return {
			// step: 4,
			selectedPlan: {
				period: null,
				plan: null,
			}
    }
  },
	computed: {
		step() {
			return this.$route.name;
		},
		notificationsOpen() {
			return this.$store.state.notificationsOpen;
		},
	},
	methods: {
		gotoChooseYourPlan(){
			if (this.$route.name!=='choose-your-plan')
				this.$router.push('/settings/billing/choose-your-plan');
		},
		openIntercom() {
			window.Intercom("show");
		},
		notifToggle() {
			this.$store.dispatch("notificationsOpenToggle");
		},
		changeStep(value){
			this.step = value;
		},
		planChoose(plan){
			console.log('plan:', plan);
			this.selectedPlan = plan;
		},
		updateSelectedPlanData(plan){
			this.selectedPlan = plan;
		}
	},
};
</script>

<style lang="scss" >
.form_steps_label {
	&.active {
		cursor: pointer;
	}
}
.billing-page .header_tabs .form_steps_label.current .icon {
	transform: rotate(90deg);
}
.billing-page .header_tabs .form_steps_label.de_active {
	color: #C5C7D2;
}
.billing-page .header_tabs .form_steps_label.de_active .icon {
	filter: grayscale(1) opacity(0.4);
}
</style>
